import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const GeneratePackageIdDetailRBAC = {
  pageID: 'ae7be455e36e0509691a64191cc80248',
  elementID: {
    ViewPage: 'b89b8578b18133d6770cfb9023b2549c',
    Reprint: '4b1d21697b323900821829a8e701e353',
  },
} as const

export const useRBACGeneratePackageIdDetailPage = createUseRBAC(
  GeneratePackageIdDetailRBAC.elementID,
)

export type UseRBACGeneratePackageIdDetailPageType = ReturnType<
  typeof useRBACGeneratePackageIdDetailPage
>
